import React, { FC } from 'react';

const ShareIcon: FC = () => {
    return (
        <svg className="svg-inline" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M4.11328 14.4717V16.1383C4.11328 16.5804 4.28888 17.0043 4.60144 17.3169C4.914 17.6294 5.33792 17.805 5.77995 17.805H15.7799C16.222 17.805 16.6459 17.6294 16.9585 17.3169C17.271 17.0043 17.4466 16.5804 17.4466 16.1383V14.4717"
                stroke="currentColor"
                strokeWidth="1.6"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M6.61328 7.80485L10.7799 3.63818L14.9466 7.80485"
                stroke="currentColor"
                strokeWidth="1.6"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M10.7793 3.63818V13.6382"
                stroke="currentColor"
                strokeWidth="1.6"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default ShareIcon;
